// Functions
import VerifyToken from "../../config/verifyToken";
// Components
import Header from "../../components/header";
import { Main } from "../generalStyle";
import StickyLogo from "../../components/stickyLogo";
import Patients from "../../components/patients";
import Footer from "../../components/footer";

const Home = () => (
  <>
    {VerifyToken()}
    <Header />
    <Main>
      <StickyLogo />
      <Patients />
    </Main>
    <Footer />
  </>
);

export default Home;
